import _construct from "/home/ubuntu/onesaz/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/construct";
import chroma from '../../chroma.js';
import Color from '../../Color.js';
import input from '../input.js';
import { type } from '../../utils/index.js';
import num2rgb from './num2rgb.js';
import rgb2num from './rgb2num.js';
Color.prototype.num = function () {
  return rgb2num(this._rgb);
};
var num = function num() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  return _construct(Color, args.concat(['num']));
};
Object.assign(chroma, {
  num: num
});
input.format.num = num2rgb;
input.autodetect.push({
  p: 5,
  test: function test() {
    if (arguments.length === 1 && type(arguments.length <= 0 ? undefined : arguments[0]) === 'number' && (arguments.length <= 0 ? undefined : arguments[0]) >= 0 && (arguments.length <= 0 ? undefined : arguments[0]) <= 0xffffff) {
      return 'num';
    }
  }
});
export { num };